import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../elements/logo/Logo';
import Nav from '../../common/header/Nav';
import OffcanvasMenu from './OffcanvasMenu';
import StickyHeader from './StickyHeader';
import SwitcherHeader from '../../elements/switcher/SwitcherHeader';
import MobileMenu from './MobileMenu';


const HeaderOne = () => {

    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const OffcanvasHandleClose = () => setShowOffcanvas(false);
    const OffcanvasHandleShow = () => setShowOffcanvas(true);

    const sticky = StickyHeader(100);

    const MobileMenuHandler = () => {
        document.querySelector('.mobilemenu-popup').classList.toggle("show");
        document.querySelector('body').classList.toggle("mobilemenu-show");

        var elements = document.querySelectorAll('.mobilemenu-popup .menu-item-has-children > a');
    
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.axil-submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
    }


    return (
        <>
            <style>
                {`
                .header.axil-header.header-style-1 {
                    padding: 8px 0 !important;
                    min-height: auto !important;
                }
                .axil-mainmenu {
                    padding: 0 !important;
                    min-height: 50px !important;
                }
                .header-navbar {
                    min-height: 50px !important;
                    align-items: center !important;
                    position: relative !important;
                    display: flex !important;
                    justify-content: center !important;
                }
                .header-logo {
                    height: 50px !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                }
                .header-logo h1 {
                    line-height: 50px !important;
                    margin: 0 !important;
                }
                `}
            </style>
            <header className="header axil-header header-style-1">
                <div className={`axil-mainmenu ${sticky ? "axil-sticky" : ""}`}>
                    <div className="container">
                        <div className="header-navbar">
                            <div className="header-logo">
                                <Link 
                                    to="/" 
                                    style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
                                    onClick={() => {
                                        // Scroll to top after a short delay to allow navigation
                                        setTimeout(() => {
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                        }, 100);
                                    }}
                                >
                                    <img 
                                        src={`${process.env.PUBLIC_URL || ''}/images/logo.png`} 
                                        alt="East Coast Coders LLC Logo" 
                                        style={{ 
                                            height: '80px', 
                                            marginRight: '12px',
                                            backgroundColor: 'transparent',
                                            objectFit: 'contain',
                                            filter: 'none'
                                        }}
                                        onError={(e) => {
                                            console.log('Logo failed to load:', e.target.src);
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                    <h1 className="mb-0 fw-bold" style={{ fontSize: '1.8rem', color: 'var(--color-heading)' }}>
                                        East Coast Coders LLC
                                    </h1>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

        </>
    )
}

export default HeaderOne;